import __request__ from 'routing/request';
interface GoogleWorkspaceV2CreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly service_account_key: unknown;
    readonly workspace_dataset_name: string;
    readonly name: string;
    readonly content_types: string[];
    readonly lag_offset: number;
    readonly store_full_message: boolean;
    readonly enable_throttling: boolean;
    readonly polling_interval: number;
    readonly page_size: number;
}
interface GoogleWorkspaceV2RequestImpl {
    readonly service_account_key: unknown;
    readonly workspace_dataset_name: string;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: GoogleWorkspaceV2RequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.googleworkspacev2.api.GoogleWorkspaceV2Resource/google_workspace_v2/check_credentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new Google Workspace v2 input
 */
export function create(JSONbody: GoogleWorkspaceV2CreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.googleworkspacev2.api.GoogleWorkspaceV2Resource/google_workspace_v2/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
